import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://sheetmanagement.sobalex.com/backend/public/index.php?endpoint=login", { username, password });
      if (response.data.status === "success") {
        localStorage.setItem("userRole", response.data.role);
        
        // Redirect based on role
        switch (response.data.role) {
          case "admin":
            navigate("/admin-dashboard");
            break;
          case "1Party":
            navigate("/1party-dashboard");
            break;
          case "2Party":
            navigate("/2party-dashboard");
            break;
          case "3Party":
            navigate("/3party-dashboard");
            break;
          case "4Party":
            navigate("/4party-dashboard");
            break;
          case "5Party":
            navigate("/5party-dashboard");
            break;
          case "PhotoOffice":
            navigate("/photooffice-dashboard");
            break;
          default:
            alert("Invalid role");
        }
      } else {
        alert("Invalid Credentials");
      }
    } catch (error) {
      console.error("Login error", error);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input type="text" placeholder="Username" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required />
        <input type="password" placeholder="Password" className="form-control mt-2" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <button type="submit" className="btn btn-primary mt-3">Login</button>
      </form>
    </div>
  );
}
export default Login;
